<template>
    <div>s
      <!-- Pole wyszukiwania z v-model do śledzenia wartości -->
      <input
        type="text"
        id="search"
        v-model="searchTerm"
        placeholder="Search..."
      />
  
      <!-- Przykład elementów do filtrowania -->
      <div id="wzory">
        <!-- <pre v-for="item in this.wzorFilterAll" 
        v-show="itemMatches2(item)">{{item}}</pre> -->
        <div
          v-for="item in this.wzorFilterAll"
          :id="item.artnr"
          :key="item.artnr"
          class="mycolumn"
          v-show="itemMatches2(item)"
        >
          {{ item.artnr }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        searchTerm: "", // Zmienna dla wartości pola wyszukiwania
        items: [
          { id: "item1", name: "Wzór 1" },
          { id: "item2", name: "Wzór 2" },
          { id: "item3", name: "Wzór 3" },
          // Dodaj więcej elementów w zależności od potrzeb
        ],
      };
    },
    computed: {
      ...mapGetters({
        
      wzorFilterAll: "wzorFilterAll",
      }),
      // Funkcja do filtrowania elementów na podstawie wartości w polu wyszukiwania
      filteredItems() {
        gi
      },
    },
    methods: {
      // Funkcja do określenia, czy element pasuje do wyszukiwanego hasła
      itemMatches(item) {
        return item.id.toLowerCase().includes(this.searchTerm.toLowerCase());
      },
      itemMatches2(item) {
        return item.artnr.toLowerCase().includes(this.searchTerm.toLowerCase());
      },
    },
  };
  </script>
  
  <style scoped>
  /* Stylizacja kolumn, możesz ją dostosować do swoich potrzeb */
  .mycolumn {
    display: inline-block;
    margin: 10px;
    padding: 10px;
    border: 1px solid #ccc;
  }
  </style>
  